import { Button } from '../../ui/button'

interface StepSelectionScreenProps {
	onNext: () => void
}

export function StepSelectionScreen({ onNext }: StepSelectionScreenProps) {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center px-4 py-8 md:px-0">
			<div className="flex flex-col items-center gap-8 md:gap-16">
				{/* Title - Mobile: 28px, Desktop: 48px Medium */}
				<h1 className="font-parkinsans w-full text-center text-[28px] leading-[36px] font-medium text-blue-950 md:text-[48px] md:leading-[64px]">
					Selecciona una opción
					<br className="md:hidden" />
					<span className="md:inline"> para comenzar</span>
				</h1>

				{/* Buttons Container - Vertical on mobile, horizontal on desktop */}
				<div className="flex w-full flex-col items-stretch justify-center gap-3 md:w-auto md:flex-row md:gap-4">
					{/* Es un auto a mi nombre - Solid Button */}
					<Button
						variant="primary"
						appearance="solid"
						size="l"
						onClick={onNext}
						className="h-[56px] w-full overflow-hidden rounded-xl px-6 py-4 md:h-[69px] md:w-[295px]"
					>
						Es un auto a mi nombre
					</Button>

					{/* No es un auto a mi nombre - Ghost Button */}
					<Button
						variant="primary"
						appearance="ghost"
						size="l"
						onClick={onNext}
						className="h-[56px] w-full overflow-hidden rounded-xl bg-blue-50 px-6 py-4 text-blue-800 hover:bg-blue-100 md:h-[69px] md:w-[295px]"
					>
						No es un auto a mi nombre
					</Button>
				</div>
			</div>
		</div>
	)
}
